<template>
    <v-card>
        <v-card-title style="height: 55px">
            Skier Types
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <div class="p-2">
            <v-list>
                <template v-for="(item, index) in skier_types">
                    <v-list-item :key="'skier_type_'+item.id">
                        <v-list-item-content>
                            <h5>{{ item.title }}</h5>
                            <span v-html="(item.content || '').replaceAll('\\r','').replaceAll('\\n','')"></span>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider
                        v-if="index < skier_types.length - 1"
                        :key="'_divider'+index"
                    ></v-divider>
                </template>
            </v-list>
        </div>
    </v-card>

</template>

<script>

import UiManagerMixin from "../../mixins/UiManagerMixin";

export default {
    name: "SkierTypes",

    mixins    : [UiManagerMixin],
    computed: {
        skier_types() {
            return this.$store.state.resources.skier_types;
        },
    }
}
</script>
